/* eslint-disable import/no-unresolved */

import Vue from 'vue'
import VueRouter from 'vue-router'
// eslint-disable-next-line import/no-cycle
import store from '@/store/index'

import home from '@/router/modules/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import(/* webpackChunkName: "main" */ '@/views/Main'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login'),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "ResetPassword" */ '@/views/ResetPassword'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "register" */ '@/views/Register'),
  },
  {
    path: '/qrcode-preview',
    name: 'QrcodePreview',
    component: () => import(/* webpackChunkName: "register" */ 'views/QrcodePreview'),
  },

  // 主页面相关路由
  ...home,
]

const router = new VueRouter({ routes })

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const hasLogin = JSON.parse(window.localStorage.getItem('USER_INFO'))?.ID
  const { path, params, query, name } = to

  // 正常的路由跳转逻辑
  // eslint-disable-next-line no-shadow
  const normalHandler = (path, params, query, name, withoutLogin = false) => {
    // 进入登录、注册 、扫码预览
    if (
      ['Login', 'Register', 'QrcodePreview', 'ResetPassword'].find(routeName => routeName === name)
    ) {
      next()
    } else if (!hasLogin && !withoutLogin) {
      next({ path: '/login' })
    } else {
      next()
    }
  }

  // 完全免登录路由地址
  const withoutLoginPathList = ['/' /* 默认页 */, '/main']

  // 保存当前路由信息
  store.commit('saveRoutePath', {
    path,
    params,
    query,
    name,
  })

  // 完全免登录
  if (withoutLoginPathList.some(p => p === path)) {
    next()
  }
  // 正常登录流程
  else {
    normalHandler(path, params, query, name)
  }
})

export default router
